import React from 'react';
import PropTypes from 'prop-types';

import usePatient from '~/utils/patient/hook';
import { UncontrolledTable } from '~/components';

import { TableFilterDateRange, TableFilterIdentitySource } from '~/components/Filters';

const UpcomingAppointments = ({ allData }) => {
  const [, { sacwisPersonId: sacwisId }] = usePatient();

  return (
    <UncontrolledTable
      name="upcoming-appointments"
      className="mx-4"
      endpoint={{
        url: 'data/public/list-view-cs-tbl-appointments',
        params: {
          sacwis_id: sacwisId,
          'apptcategory__!': 'Missed',
          'appttimeTs__>>': new Date().toISOString(),
          'all-data': allData ? '1' : null,
        },
      }}
      defaultSorted={[{ id: 'appttimeTs__<<', desc: false }]}
      columns={[{
        id: 'appttimeTs__<<',
        Header: 'Date & Time',
        accessor: 'attributes.appttimeTs',
        cellType: 'date-time',
        Filter: d => <TableFilterDateRange action="next" {...d} />,
      }, {
        id: 'apptcategory',
        Header: 'Appointment Type',
        accessor: 'attributes.apptcategory',
      }, {
        id: 'provider',
        Header: 'Provider',
        accessor: 'attributes.provname',
      }, {
        id: 'address',
        Header: 'Location',
        accessor: 'attributes',
        filterable: false,
        Cell: d => (
          <div className="text-white-space-normal">
            <div><strong>{d.original.attributes.departmentname}</strong></div>

            <div>
              {d.original.attributes.depaddress} {d.original.attributes.depcity},{' '}
              {d.original.attributes.depstate} {d.original.attributes.depzip}
            </div>
          </div>
        ),
      }, {
        id: 'sourceDescription',
        Header: 'Reporting Healthcare Institution',
        accessor: 'attributes.sourceDescription',
        Filter: d => <TableFilterIdentitySource {...d} />,
      }]}
    />
  );
};

UpcomingAppointments.propTypes = {
  allData: PropTypes.bool,
};

UpcomingAppointments.defaultProps = {
  allData: false,
};

export default UpcomingAppointments;
